import React from 'react';
import { faTimes, faSave } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';

interface IClassroomLaunchboxProps {
  isReadOnly: boolean;
  isSaving: boolean;
  onSave: () => void;
  onValidate: () => boolean;
}

export function ClassroomLaunchbox(props: IClassroomLaunchboxProps) {
  const { isReadOnly, isSaving, onSave, onValidate } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  return (
    <FloatingActionButtonBar>
      {!isReadOnly && <FloatingActionButton loading={isSaving} buttonText="Gem og luk" icon={faSave} onClick={handleSave} inverted />}
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
